var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-c schedule-info-wrapper",on:{"click":_vm.openScheduleSettings}},[_c('div',{staticClass:"info-section settings"},[_c('div',{staticClass:"info-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.scheduleTime && _vm.scheduleTime !== "Invalid Date" ? _vm.scheduleTime : "--/--"))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }